import { Snackbar, Alert } from '@mui/material'
import { useReactiveVar } from '@apollo/client'
import FreemiumDot from '../../../../components/FreemiumDot'
import { modalVar, premiumModalContentVar } from '../../../../providers/apollo/cache'

export default function PremiumFeatureModal() {
  const modal = useReactiveVar(modalVar)
  const premiumModalContent = useReactiveVar(premiumModalContentVar)

  const handleClose = () => {
    modalVar(null)
  }

  return (
    <Snackbar onClose={handleClose} open={modal === 'premiumFeature'} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
        icon={<FreemiumDot size={45} showCrown />}
        sx={{
          maxWidth: '960px',
          radius: 8,
          color: 'white',
          bgcolor: '#29344A',
          marginBottom: '12px',
          zIndex: 100,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
          // textAlign: 'center'
        }}
      >
        {premiumModalContent}
      </Alert>
    </Snackbar>
  )
}
